import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { DictionaryContextOperationsResponse } from './dictionary-context-operations.response';

@jsonObject
export class DictionaryDetailsResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(Number)
  public readonly position!: number;

  @jsonMember(String)
  public readonly label!: string;

  @jsonMember(String)
  public readonly slug!: string;

  @jsonMember(Date)
  public readonly createdAt!: string;

  @jsonMember(DictionaryContextOperationsResponse)
  public readonly contextOperations!: DictionaryContextOperationsResponse;
}
